import { Button } from 'app/components/buttons';
import { DropdownButtonArrow, StyledDropdownButton } from 'app/components/date-range-selector/DropdownButton.styles';
import { DataAttributeProps } from 'app/types';
import { ComponentProps, PropsWithChildren } from 'react';

type ButtonProps = ComponentProps<typeof Button>;
type PickedButtonProps = Pick<ButtonProps, 'className' | 'onClick' | 'disabled'>;
type OmittedButtonProps = Omit<ButtonProps, 'className' | 'onClick' | 'disabled'>;

type DropdownButtonProps = PropsWithChildren<
  {
    isActive?: boolean;
    hasValue?: boolean;
    buttonProps?: OmittedButtonProps & DataAttributeProps;
  } & PickedButtonProps
>;

export const DropdownButton = ({
  isActive,
  hasValue,
  children,
  buttonProps,
  className,
  disabled,
  onClick,
}: DropdownButtonProps) => {
  return (
    <StyledDropdownButton
      $isActive={isActive}
      $hasValue={hasValue}
      className={className}
      disabled={disabled}
      onClick={onClick}
      {...buttonProps}
    >
      <span>{children}</span>
      {!hasValue && <DropdownButtonArrow />}
    </StyledDropdownButton>
  );
};
